<template>
  <div class="myThesisList">
    <el-main>
      <UserCenterTop />
      <el-row class="nofull event_content">
        <UserMenu :myMenuActiveId="myMenuActiveId" />
        <el-main>
          <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item>学者中心</el-breadcrumb-item>
            <el-breadcrumb-item>{{ eventTitle }}</el-breadcrumb-item>
            <el-breadcrumb-item>我的投稿</el-breadcrumb-item>
          </el-breadcrumb>
          <div class="row_header myEventDescPart">
            <MyEventDesc @eventTitle="et" />
          </div>
          <MyEventMenu :myEventMenuActiveIndex="myEventMenuActiveIndex" />
          <el-row :gutter="20" class="title_row">
            <el-col :span="20">
              <div class="textTitle">会议投稿：</div>
            </el-col>
            <el-col :span="4">
              <el-button
                class="fr"
                style="margin-top: 10px"
                type="primary"
                @click="handleShowThesisForm"
                :disabled="!contributeStarted || !contributeNotEnded"
              >
                <span v-if="!contributeStarted">投稿尚未开始</span>
                <span v-else-if="!contributeNotEnded">投稿已结束</span>
                <span v-else>继续投稿</span>
              </el-button>
            </el-col>
          </el-row>
          <!-- 投稿列表 -->
          <el-row style="position: relative; min-height: 300px">
            <div class="contentEmpty" v-if="this.thesisList.length === 0">
              暂无投稿
            </div>
            <el-card
              class="box-card thesisList-box"
              v-for="(item, index) in thesisList"
              :key="index"
            >
              <el-row :gutter="10">
                <el-col :span="16" style="font-weight: bold">
                  <div>稿件ID：{{ item.manuscript_id }}</div>
                </el-col>
              </el-row>
              <el-row :gutter="10">
                <el-col :span="16" style="font-weight: bold">
                  <div>论文标题(中文)：{{ item.title_zh }}</div>
                  <div>Thesis Title (en)：{{ item.title_en }}</div>
                </el-col>
                <el-col :span="6">
                  <div>分会议名称：{{ item.sub_forum_name }}</div>
                  <div>所属领域：{{ item.domain_name }}</div>
                </el-col>
              </el-row>
              <el-divider></el-divider>
              <el-row :gutter="10">
                <el-col :span="24" style="font-weight: bold">
                  <div>作者：</div>
                  <div>
                    <el-table
                      :data="toJson(item.author_info)"
                      border
                      style="width: 100%"
                    >
                      <!--                                            <el-table-column type="expand">-->
                      <!--                                                <template slot-scope="props">-->
                      <!--                                                    <el-form label-position="left" inline class="demo-table-expand">-->
                      <!--                                                        <el-form-item label="中文姓">-->
                      <!--                                                            <span>{{ props.row.last_name_zh }}</span>-->
                      <!--                                                        </el-form-item>-->
                      <!--                                                        <el-form-item label="中文名">-->
                      <!--                                                            <span>{{ props.row.first_name_zh }}</span>-->
                      <!--                                                        </el-form-item>-->
                      <!--                                                        <el-form-item label="First name(en)">-->
                      <!--                                                            <span>{{ props.row.first_name_en }}</span>-->
                      <!--                                                        </el-form-item>-->
                      <!--                                                        <el-form-item label="Last name(en)">-->
                      <!--                                                            <span>{{ props.row.last_name_en }}</span>-->
                      <!--                                                        </el-form-item>-->
                      <!--                                                        <el-form-item label="单位名称">-->
                      <!--                                                            <span>{{ props.row.organization_zh }}</span>-->
                      <!--                                                        </el-form-item>-->
                      <!--                                                        <el-form-item label="Organization(en)">-->
                      <!--                                                            <span>{{ props.row.organization_en }}</span>-->
                      <!--                                                        </el-form-item>-->
                      <!--                                                        <el-form-item label="电话">-->
                      <!--                                                            <span>{{ props.row.phone }}</span>-->
                      <!--                                                        </el-form-item>-->
                      <!--                                                        <el-form-item label="邮箱">-->
                      <!--                                                            <span>{{ props.row.email }}</span>-->
                      <!--                                                        </el-form-item>-->
                      <!--                                                    </el-form>-->
                      <!--                                                </template>-->
                      <!--                                            </el-table-column>-->
                      <!--                                            <el-table-column-->
                      <!--                                                    align="center"-->
                      <!--                                                    prop="isFirstAuthor"-->
                      <!--                                                    label="第一作者"-->
                      <!--                                                    width="90">-->
                      <!--                                                <template slot-scope="scope">-->
                      <!--                                                    <span v-if="scope.$index===0">-->
                      <!--                                                        <i class="el-icon-check"></i>-->
                      <!--                                                    </span>-->
                      <!--                                                    <span v-else></span>-->
                      <!--                                                </template>-->
                      <!--                                            </el-table-column>-->
                      <af-table-column
                        align="center"
                        prop="is_corresponding_author"
                        label="是否通信作者"
                      >
                        <template slot-scope="scope">
                          <span
                            v-if="scope.row.is_corresponding_author === true"
                          >
                            <i class="el-icon-check"></i>
                          </span>
                          <span v-else></span>
                        </template>
                      </af-table-column>
                      <af-table-column label="姓名">
                        <template slot-scope="scope">
                          <div>
                            {{ scope.row.last_name_zh
                            }}{{ scope.row.first_name_zh }}
                          </div>
                          <div>
                            {{ scope.row.first_name_en
                            }}{{ scope.row.last_name_en }}
                          </div>
                        </template>
                      </af-table-column>
                      <af-table-column label="单位名称">
                        <template slot-scope="scope">
                          <div>{{ scope.row.organization_zh }}</div>
                          <div>{{ scope.row.organization_en }}</div>
                        </template>
                      </af-table-column>
                      <af-table-column
                        :resizable="false"
                        prop="email"
                        label="Email"
                      >
                      </af-table-column>
                    </el-table>
                  </div>
                </el-col>
              </el-row>
              <el-divider></el-divider>
              <div style="margin-bottom: 8px">
                论文关键词(中文):
                <TagInput readonly :value="item.keywords_zh" />
              </div>
              <div style="margin-bottom: 8px">
                论文关键词(英文):
                <TagInput readonly :value="item.keywords_en" />
              </div>
              <el-row :gutter="10">
                <el-col :span="24">
                  <div>论文摘要(中文)：</div>
                  <div>{{ item.abstract_zh }}</div>
                  <div style="margin-top: 10px">Thesis abstract (en)：</div>
                  <div>{{ item.abstract_en }}</div>
                </el-col>
              </el-row>
              <el-divider></el-divider>
              <el-row :gutter="10">
                <el-col :span="24" v-if="false">
                  <div>
                    论文摘要文档：
                    <span v-if="item.abstract_file_path === ''">无</span>
                    <span v-else>
                      <router-link
                        target="_blank"
                        :to="{
                          path:
                            '/forum-pub-api/v1/minio/getFile?file_url=' +
                            item.abstract_file_path,
                        }"
                      >
                        <span>{{ item.abstract_file_name }}</span>
                      </router-link>
                    </span>
                  </div>
                </el-col>
                <el-col :span="24">
                  <div>
                    论文全文文档：<span v-if="item.manuscript_file_path === ''"
                      >未上传</span
                    >
                    <span v-else>
                      <router-link
                        target="_blank"
                        :to="
                          '/forum-pub-api/v1/minio/getFile?file_url=' +
                          item.manuscript_file_path
                        "
                      >
                        <span>{{ item.manuscript_file_name }}</span>
                      </router-link>
                    </span>
                  </div>
                </el-col>
              </el-row>
              <el-divider></el-divider>
              <el-row>
                <span style="margin-right: 20px"
                  >同意入选年会论文：
                  <span v-if="item.is_working_paper"> 是 </span>
                  <span v-else> 否 </span>
                </span>
              </el-row>
              <el-divider></el-divider>
              <el-row>
                <span style="margin-right: 20px"
                  >评审结果：
                  <span v-if="item.review_status === 0"> 未评审 </span>
                  <span v-else-if="item.review_status === 1"> 未通过 </span>
                  <span v-else-if="item.review_status === 2"> 已通过 </span>
                  <span v-else> 已录用 </span>
                </span>
                <span> 评审内容：{{ item.review_content }} </span>
                <!--
                                <el-link
                                        type="primary"
                                        @click="handleDialogVisible(index)">审核详情</el-link>
                                        -->
                <template v-if="contributeNotEnded">
                  <el-link
                    type="primary"
                    style="float: right"
                    @click="handleGetThesisForm(index, item)"
                    >编辑</el-link
                  >
                  <el-popconfirm
                    title="确认删除投稿？"
                    @onConfirm="deleteManuscript(item.manuscript_id)"
                  >
                    <el-link
                      slot="reference"
                      type="danger"
                      style="float: right; margin-right: 8px"
                      >删除</el-link
                    >
                  </el-popconfirm>
                </template>
                <span v-else style="float: right">投稿已结束</span>
              </el-row>
            </el-card>
            <el-dialog
              title="审核详情"
              :visible.sync="dialogVisible"
              width="30%"
            >
              <span style="text-align: left">
                <p>审核论文：{{ reviewThesisTitle }}</p>
                <p>
                  审核结果：
                  <span v-if="reviewStatus === 0">未评审</span>
                  <span v-else-if="reviewStatus === 1">通过评审</span>
                  <span v-else>未通过评审</span>
                </p>
                <p>审核日期：{{ reviewTime }}</p>
                <p>审核详情：{{ reviewContent }}</p>
              </span>
              <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="handleClose">确 定</el-button>
              </span>
            </el-dialog>
          </el-row>
        </el-main>
      </el-row>
    </el-main>
    <ThesisForm
      ref="child"
      :fields="fields"
      :eventTitle="eventTitle"
      :eventId="forumId"
    />
  </div>
</template>

<script>
import UserMenu from '@/components/UserMenu';
import UserCenterTop from '@/components/UserCenterTop';
import MyEventMenu from '@/components/MyEventMenu';
import MyEventDesc from '@/components/MyEventDesc';
import ThesisForm from '@/components/ThesisForm';
import TagInput from '@/components/TagInput.vue';

import { getDomain } from '@/apis/domain';
import { getMyThesisList, deleteManuscript } from '@/apis/myThesisList';
import { getEventDetail } from '@/apis/eventDetail.js';

export default {
  name: 'MyThesisList',
  components: {
    UserMenu,
    UserCenterTop,
    MyEventMenu,
    MyEventDesc,
    ThesisForm,
    TagInput,
  },
  mounted() {
    this.$emit('activeIndex', '3');
    this.$emit('pageClass', 'userCenter');
    let forum_id = this.$route.query.eventId;
    console.log('desc' + forum_id);
    this.forumId = Number(forum_id);
    getDomain(this.forumId)
      .then((res) => {
        if (res.status === 200) {
          if (res.data.success === true) {
            this.fields = res.data.data.items;
          } else {
            this.$message.error(res.data.message);
          }
        } else {
          this.$message.error('未请求成功');
          console.log('错误');
        }
      })
      .catch((error) => {
        console.log(error);
      });
    // 获取会议详情
    getEventDetail(forum_id)
      .then((res) => {
        if (res.status === 200) {
          if (res.data.success === true) {
            console.log(res.data);
            this.eventDesc = res.data.data.item;
            this.eventDesc.setting_json = res.data.data.item.setting_json;
            let eventTitle = this.eventDesc.name;
            this.$emit('eventTitle', eventTitle);
          } else {
            this.$message({
              showClose: true,
              message: res.data.message,
              type: 'success',
            });
          }
        } else {
          this.$message.error('未请求成功');
        }
      })
      .catch((error) => {
        console.log(error);
      });
  },
  data() {
    return {
      forumId: null,
      myMenuActiveId: '1',
      myEventMenuActiveIndex: '2',
      eventTitle: '',
      formLabelWidth: '90px',
      // thesis list item data
      fields: [],
      dialogVisible: false,
      reviewThesisTitle: '',
      reviewStatus: '',
      reviewTime: '',
      reviewContent: '',
      eventDesc: {
        setting_json: {},
        contacts: '',
        tel: '',
      },
      /* thesisList: [

                    {
                        thesisTitle_zh: '论中国经济发展中的制造业走向',
                        thesisTitle_en: 'On the trend of manufacturing industry in China\'s economic development',
                        authorLastName_zh: '张',
                        authorFirstName_zh: '某某',
                        authorLastName_en: 'zhang',
                        authorFirstName_en: 'Moumou',
                        subEventTitle: '分会议1',
                        thesisField: '经济学',
                        uploadTime: '2020-07-13',
                        thesisState: '待审核',
                        examineDate: '2020-07-15',
                        examineNotes: '您的论文中有一处引用发现错误，在第385行，因为涉及到具体案例，请改正后重新提交。',
                        dialogVisible: false,
                    },
                    {
                        thesisTitle_zh: '论中国经济发展中的制造业走向',
                        thesisTitle_en: 'On the trend of manufacturing industry in China\'s economic development',
                        authorLastName_zh: '张',
                        authorFirstName_zh: '某某',
                        authorLastName_en: 'zhang',
                        authorFirstName_en: 'Moumou',
                        subEventTitle: '分会议1',
                        thesisField: '经济学',
                        uploadTime: '2020-07-11',
                        thesisState: '待审核',
                        examineNotes: '论文中多次出现同一段文本，请修正后再次上传更新。另外第390页处有明显的反动倾向，请作出修正。',
                        examineDate: '2020-07-15',
                        dialogVisible: false,
                    },
                ],
                */
    };
  },
  methods: {
    et(data) {
      this.eventTitle = data;
    },

    handleShowThesisForm() {
      if (
        localStorage.eleToken !== null &&
        localStorage.eleToken !== '' &&
        localStorage.eleToken !== undefined &&
        this.$store.state.toGetCurrentUser.isLoginKey === 1
      ) {
        this.$refs.child.manuscriptId = null;
        this.$refs.child.openForm();
      } else {
        this.$store.commit('blOpenLoginBox', true);
      }
    },
    handleGetThesisForm(index) {
      if (
        localStorage.eleToken !== null &&
        localStorage.eleToken !== '' &&
        localStorage.eleToken !== undefined &&
        this.$store.state.toGetCurrentUser.isLoginKey === 1
      ) {
        this.$refs.child.manuscriptId = this.thesisList[index].manuscript_id;
        this.$refs.child.openForm();
      } else {
        this.$store.commit('blOpenLoginBox', true);
      }
    },

    /*
            handleDialogVisible(index){
                this.dialogVisible= true;
                this.reviewThesisTitle = this.thesisList[index].title_zh;
                this.reviewStatus = this.thesisList[index].review_status;
                this.reviewContent = this.thesisList[index].review_content;
            },
             */

    // 弹框关闭
    handleClose() {
      this.dialogVisible = false;
    },
    toJson(str) {
      let jsonToObj = JSON.parse(str);
      // console.log(jsonToObj);
      return jsonToObj;
    },
    async deleteManuscript(id) {
      await deleteManuscript(id);
      let forum_id = Number(this.$route.query.eventId);
      // 获取投稿列表
      getMyThesisList({
        forum_id: forum_id,
      })
        .then((res) => {
          if (res.status === 200) {
            if (res.data.success === true) {
              this.$store.commit('AddMyThesisList', res.data.data.items);
            } else {
              this.$message.error(res.data.message);
            }
            console.log('ThesisList', res.data);
          } else {
            this.$message.error('未请求成功');
            console.log('错误');
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    compareDate(dt1, dt2) {
      let x1 = new Date(dt1.getFullYear(), dt1.getMonth(), dt1.getDate());
      let x2 = new Date(dt2.getFullYear(), dt2.getMonth(), dt2.getDate());

      return x1.getTime() - x2.getTime();
    },
  },
  computed: {
    thesisList: {
      get() {
        return this.$store.state.toGetMyThesisList.thesisList;
      },
    },
    contributeStarted() {
      const { contribute_start_time } = this.eventDesc.setting_json;
      if (!contribute_start_time) return true;
      return this.$moment(this.eventDesc.server_time).isAfter(
        contribute_start_time,
      );
    },
    contributeNotEnded() {
      const { contribute_end_time } = this.eventDesc.setting_json;
      if (!contribute_end_time) return true;
      return this.$moment(this.eventDesc.server_time).isBefore(
        contribute_end_time,
      );
    },
  },
};
</script>

<style scoped></style>
